import React from 'react';
import './PrinciMessage.css';
import principalImage from './school-logo.jpg';

const PrinciMessage = () => {
  return (
    <section className="princi-message-wrapper">
      <div className="princi-image-section">
        <img src={principalImage} alt="Principal" className="princi-img" />
      </div>

      <div className="princi-text-section">
        <h2 className="princi-title">Founder's Message</h2>
        <blockquote className="princi-quote">
          <p>"The purpose of education is to replace an empty mind with an open one."</p>
          <footer>– Malcolm Forbes</footer>
        </blockquote>
        <p className="princi-body">
          Welcome to Oxford Convent English Medium School, where education meets holistic growth.
          We foster curiosity, creativity, and critical thinking while promoting values like
          discipline, integrity, and respect.
        </p>
        <p className="princi-body">
          Our curriculum ensures academic excellence and life skills, supported by dedicated
          educators and enriching co-curricular activities. We work closely with parents to
          provide personalized guidance and nurture confident, responsible individuals.
        </p>
        <p className="princi-signature">
          With Regards, <br />
          <strong>School Founder</strong>
        </p>
      </div>
    </section>
  );
};

export default PrinciMessage;
